import { useNavigate } from "react-router-dom";
import MotionStagger from "../common/Motion/MotionStagger";
import MotionItem from "../common/Motion/MotionItem";
import HoverButton from "../common/Motion/HoverButton";
import { homeCtaContent } from "../../data/homeData";

function HomeCTA() {
  const navigate = useNavigate();
  const data = homeCtaContent;

  return (
    <section className="relative overflow-hidden bg-[#071A2F] py-20 lg:py-24">
      <div className="relative mx-auto max-w-4xl px-6">
        <MotionStagger>
          <MotionItem>
            <div className="text-center">
              <span className="text-sm font-semibold uppercase tracking-[0.3em] text-red-500">
                {data.eyebrow}
              </span>

              <h2 className="mt-4 text-3xl sm:text-4xl font-bold leading-tight text-white lg:text-5xl">
                {data.title}
              </h2>
            </div>

            <div className="mt-10 space-y-6 text-center sm:text-left max-w-3xl mx-auto">
              <p className="text-base sm:text-lg leading-relaxed text-slate-300 text-justify">
                {data.paragraphs[0]}
              </p>

              <div className="border-l-2 border-red-500 pl-6 sm:pl-8 py-1 space-y-4">
                <p className="text-base sm:text-lg leading-relaxed text-white text-justify">
                  {data.objectiveLead}
                </p>

                <p className="text-base sm:text-lg leading-relaxed text-white font-medium text-justify">
                  {data.objective}
                </p>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap justify-center sm:justify-start gap-4">
              <HoverButton
                type="button"
                onClick={() => navigate(data.primaryLink)}
                className="group relative inline-flex items-center justify-center overflow-hidden rounded-full bg-red-600 px-8 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-1 hover:scale-[1.03] hover:bg-red-700 sm:px-10 sm:py-4 sm:text-base"
              >
                <span className="relative z-10">{data.primaryLabel}</span>
                <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-all duration-700 group-hover:translate-x-full" />
              </HoverButton>
              <HoverButton
                type="button"
                onClick={() => navigate(data.secondaryLink)}
                className="group relative inline-flex items-center justify-center overflow-hidden rounded-full border border-white/20 px-8 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-1 hover:scale-[1.03] hover:bg-white hover:text-slate-900 hover:shadow-xl sm:px-10 sm:py-4 sm:text-base"
              >
                <span className="relative z-10">{data.secondaryLabel}</span>
                <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-all duration-700 group-hover:translate-x-full" />
              </HoverButton>
            </div>
          </MotionItem>
        </MotionStagger>
      </div>
    </section>
  );
}

export default HomeCTA;
